import { render, staticRenderFns } from "./PersonalCardTypes.vue?vue&type=template&id=64543e10&"
import script from "./PersonalCardTypes.vue?vue&type=script&lang=js&"
export * from "./PersonalCardTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports